import React from "react";
import { darkTheme } from "@backstage/theme";
import { ThemeProviderOverride } from "../providers";

// @TODO - Fix Typing Issues
export const radiatorDarkTheme: any = {
  ...darkTheme,
  title: "Default Dark Theme",
  variant: "dark" as "dark",
  id: "dark",
  Provider: ({ children }: { children: React.ReactNode }) => (
    <ThemeProviderOverride theme={radiatorDarkTheme}>
      {children}
    </ThemeProviderOverride>
  ),
};
